import { c as _c } from "react/compiler-runtime";
import { AuthorTooltip } from '@cc-shopping/ui/composites/AuthorTooltip';
import type { AuthorTooltipProps } from '@cc-shopping/ui/composites/AuthorTooltip/types';
import { Typography } from '@mui/material';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import CheckIcon from './CheckIcon';
import TooltipTrigger from './TooltipTrigger';
export default function EditorAndReviewer(t0) {
  const $ = _c(14);
  const {
    editorOrReviewer,
    isReview: t1
  } = t0;
  const isReview = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckIcon />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = isReview ? "Reviewed" : "Edited";
  let t4;
  if ($[1] !== t3) {
    t4 = <Typography variant="textSmall" color="text.secondary" marginRight={1}>{t3} by{" "}</Typography>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TooltipTrigger />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== editorOrReviewer.avatarMiniatureURL || $[5] !== editorOrReviewer.bio || $[6] !== editorOrReviewer.link || $[7] !== editorOrReviewer.name || $[8] !== editorOrReviewer.socialMediaLinks || $[9] !== editorOrReviewer.userPage) {
    t6 = <AuthorTooltip name={editorOrReviewer.name} avatarMiniatureURL={editorOrReviewer.avatarMiniatureURL} socialMediaLinks={editorOrReviewer.socialMediaLinks} link={editorOrReviewer.link} userPage={editorOrReviewer.userPage} trigger={t5} bio={editorOrReviewer.bio} Renderer={StructuredContentRenderer} />;
    $[4] = editorOrReviewer.avatarMiniatureURL;
    $[5] = editorOrReviewer.bio;
    $[6] = editorOrReviewer.link;
    $[7] = editorOrReviewer.name;
    $[8] = editorOrReviewer.socialMediaLinks;
    $[9] = editorOrReviewer.userPage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div data-testid="topAuthorComponent">{t2}{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}